.inputContainer {
    position: sticky;
    bottom: 0;
    z-index: 10;

    max-width: var(--app-thread-width);
    margin: 0 auto;
    padding: 0 var(--mantine-spacing-md);
    box-sizing: border-box;
    width: 100%;
    padding: var(--mantine-spacing-xs);

    @container (min-width: $mantine-breakpoint-xs) {
        padding: var(--mantine-spacing-md);
    }
}
